import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { IClient } from '../../../shared/interfaces/IClient';
import { getUser } from '../../../core/store/actions/core.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.reducer';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reset-password-page',
  templateUrl: './reset-password-page.component.html',
  styleUrls: ['./reset-password-page.component.scss'],
})
export class ResetPasswordPageComponent implements OnInit {
  resetPasswordForm: FormGroup;
  loading = false;
  success = false;
  error = false;
  token: string;
  apiSuccessMessage: any;
  apiErrorMessage: any;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private store: Store<AppState>,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.token = params['token'];
      // this.loading = false;

      if (!(this.token.length === 20)) {
        this.router.navigateByUrl('/home');
      }


      this.resetPasswordForm = this.fb.group(
        {
          newPassword: [
            '',
            [
              Validators.required,
              Validators.minLength(8),
              Validators.pattern('(?=.*[0-9])(?=.*[A-Z]).{8,}'),
            ],
          ],
          confirmPassword: ['', Validators.required],
        },
        { validators: this.passwordMatchValidator }
      );

      this.resetPasswordForm.get('newPassword').valueChanges.subscribe(() => {
        this.resetPasswordForm.get('confirmPassword').updateValueAndValidity();
      });

      this.resetPasswordForm
        .get('confirmPassword')
        .valueChanges.subscribe(() => {
          this.resetPasswordForm.get('newPassword').updateValueAndValidity();
        });



    });
  }

  passwordMatchValidator(formGroup: FormGroup): { mismatch: boolean } | null {
    const newPassword = formGroup.get('newPassword')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;
    return newPassword === confirmPassword ? null : { mismatch: true };
  }

  resetPassword(): void {
    if (this.resetPasswordForm.valid) {
      this.loading = true;
      const apiUrl = environment.apiUrl;
      const payload = { password: this.resetPasswordForm.value.newPassword, password_confirmation: this.resetPasswordForm.value.confirmPassword };

      this.http.post(`${apiUrl}clients/resetPassword/${this.token}`, payload).subscribe({
        next: (response) => {
          this.success = true;
          this.error = false;
          this.loading = false;

          this.apiSuccessMessage = response["message"];

          this.resetPasswordForm.reset();
        },
        error: (error) => {
          this.error = true;
          this.success = false;
          this.loading = false;

          this.apiErrorMessage = error["error"]["message"];

          console.error('Error al cambiar la contraseña: ', error);
        },
      });
    }
  }

}
